import React from 'react'
import View from './view'

const VenuesManage = ({ ...props }) => {
    return <View {...props} />
}

export default VenuesManage
